import {useQuery} from '@tanstack/react-query';
import {AxiosError, AxiosResponse} from 'axios';
import {AxiosErrorToast} from '../general/ReusableFunctions';
import {IApiDataResponse} from '../../dto/API.dto';
import {ICompanySchool} from '../../dto/CompanySchool.dto';
import {ICompanyFacility} from '../../dto/CompanyFacility.dto';
import axiosInstance from '../../axiosConfig';

interface ICompanyFacilityCust extends ICompanyFacility {
  selected: boolean;
}

interface ICompanySchoolsFacilities extends ICompanySchool {
  facilities: ICompanyFacilityCust[];
}

const getCmpySchoolFacilities = (company_id: number) => {
  return axiosInstance
    .get(`/v1/company/${company_id}/school/facilities`)
    .then(
      (
        response: AxiosResponse<IApiDataResponse<ICompanySchoolsFacilities[]>>,
      ) => {
        return response.data.data;
      },
    )
    .catch((error: AxiosError) => {
      AxiosErrorToast(error, 'Error in listing devices');
      throw error;
    });
};

export const useRqListCmpySchoolsFacilities = (
  company_id: number,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: ['api/v1/company', company_id, 'school/facilities'],
    queryFn: () => getCmpySchoolFacilities(company_id),
    refetchOnWindowFocus: false,
    retry: false,
    enabled: enabled,
  });
};
